var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIconKakaotalk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 51.447,
    viewBox: "0 0 56 51.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#391b1b;}.b{fill:#fae300;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-932 -672)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(876.902 594.609)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M83.1,77.391c-15.465,0-28,9.91-28,22.136,0,7.957,5.311,14.931,13.283,18.832-.586,2.187-2.12,7.922-2.429,9.148-.379,1.523.559,1.5,1.173,1.092.481-.321,7.673-5.209,10.776-7.319a35.457,35.457,0,0,0,5.2.382c15.464,0,28-9.912,28-22.136s-12.536-22.136-28-22.136",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.249 92.811)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M113.981,185.048h-8.188a1.393,1.393,0,1,0,0,2.785h2.662v9.809A1.362,1.362,0,0,0,109.813,199h.3a1.361,1.361,0,0,0,1.356-1.359v-9.809h2.514a1.393,1.393,0,1,0,0-2.785Z",
    transform: "translate(-104.4 -184.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M265.861,195.224h-3.807V185.206a1.511,1.511,0,1,0-3.021,0V196a1.468,1.468,0,0,0,.023.242,1.291,1.291,0,0,0-.023.241,1.263,1.263,0,0,0,1.264,1.265h5.565a1.264,1.264,0,0,0,0-2.528Z",
    transform: "translate(-236.603 -183.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M330.708,195.683l-4.243-5.573,3.834-3.835a1.33,1.33,0,1,0-1.881-1.88l-4.746,4.746v-3.935a1.511,1.511,0,1,0-3.022,0v11.13a1.511,1.511,0,1,0,3.022,0V192.9l.863-.862,4.014,5.267a1.351,1.351,0,1,0,2.16-1.624Z",
    transform: "translate(-289.282 -183.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M179.581,196.045,175.5,184.882l-.013-.012a2.006,2.006,0,0,0-1.912-1.176,1.948,1.948,0,0,0-1.984,1.405,1.863,1.863,0,0,0-.078.184L167.5,196.045a1.353,1.353,0,1,0,2.554.9l.694-1.982h5.585l.694,1.982a1.353,1.353,0,1,0,2.554-.9Zm-7.947-3.614,1.877-5.355c.021,0,.039.006.06.006l1.875,5.349Z",
    transform: "translate(-158.281 -183.694)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKakaotalk);
export default __webpack_public_path__ + "static/media/icon_kakaotalk.77722c00676976cce98d74e4c0f1ea0c.svg";
export { ForwardRef as ReactComponent };